import { ROUTELIST } from 'routes';
import { APP_MESSAGES } from 'common/constants/languages';

export const NAV_LINKS = [
  {
    key: ROUTELIST.TERM.KEY,
    url: ROUTELIST.TERM.URL,
    is_external: false,
    message: APP_MESSAGES.termOfService,
  },
  {
    key: ROUTELIST.PRIVACY.KEY,
    url: ROUTELIST.PRIVACY.URL,
    is_external: false,
    message: APP_MESSAGES.privacyPolicy,
  },
  // {
  //   key: ROUTELIST.EXPERT_REGISTRATION.KEY,
  //   url: ROUTELIST.EXPERT_REGISTRATION.URL,
  //   is_external: false,
  //   message: APP_MESSAGES.faq,
  // },
];